module.exports = __webpack_public_path__ + "img/eye.40c923fd.svg";